import { useTranslationRaw } from '../../hooks/useTranslation.mjs';
import '../../types/index.mjs';
import EN_TRANSLATION from './translations/en.json.mjs';
import { Language } from '../../types/constants.mjs';
"use strict";
const useMicrositeMenuTranslations = language => {
  return useTranslationRaw({
    language,
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ja]: () => import('./translations/ja.json.mjs').then(res => res.default),
      [Language.Ar]: () => import('./translations/ar.json.mjs').then(res => res.default),
      [Language.De]: () => import('./translations/de.json.mjs').then(res => res.default),
      [Language.Es]: () => import('./translations/es.json.mjs').then(res => res.default),
      [Language.El]: () => import('./translations/el.json.mjs').then(res => res.default),
      [Language.It]: () => import('./translations/it.json.mjs').then(res => res.default),
      [Language.Pt]: () => import('./translations/pt.json.mjs').then(res => res.default),
      [Language.Zh]: () => import('./translations/zh-Hans.json.mjs').then(res => res.default),
      [Language.Fr]: () => import('./translations/fr.json.mjs').then(res => res.default),
      [Language.Tw]: () => import('./translations/zh-Hant-TW.json.mjs').then(res => res.default)
    }
  });
};
export { useMicrositeMenuTranslations };
//# sourceMappingURL=translations.mjs.map
